import { z } from "zod";

export const DocumentationPage = z.object({
  type: z.literal("DocumentationPage"),
  id: z.string(),
  persistentId: z.string(),
  shortPersistentId: z.string(),
  designSystemVersionId: z.string(),
  parentPersistentId: z.string().nullish(),
  sortOrder: z.number(),
  title: z.string(),
  slug: z.string(),
  userSlug: z.string().nullish(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type DocumentationPage = z.infer<typeof DocumentationPage>;
